export default {
  filterModes: {
    label: 'Mode',
    options: {
      like: 'Like',
      equals: 'Equals',
      list: 'List',
    },
  },
  noItemsSelected: 'No items selected',
  confirm: 'Are you sure?',
  fields: {
    action: 'Action',
    status: 'Status',
  },
  status: {
    title: 'Statuses',
    active: 'Active',
    inactive: 'Inactive',
  },
  searchByColumns: 'Search by fields',
  search: 'Search',
  noMatchingResults: 'No matching records found',
  noDataAvailable: 'No data available',
  rowsPerPageText: 'Rows per page:',
  records: 'Records',
  page: 'Page',
  from: 'from',
  add: 'Add',
  all: 'All',
  buttons: {
    edit: 'Edit',
    suspend: 'Suspend',
    restore: 'Restore',
    delete: 'Delete',
    editSelected: 'Edit selected',
    suspendSelected: 'Suspend selected',
    restoreSelected: 'Restore selected',
    deleteSelected: 'Delete selected',
    download: 'Download',
    show: 'Show',
    refreshTable: 'Refresh table',
    copyToExcel: 'Copy to Excel',
    clearFilters: 'Clear filters',
    move: 'Move',
    insert: 'Insert',
    insertUnassigned: 'Insert unassigned',
    cancelMove: 'Cancel move',
  },
}
